import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { TechChip } from "@/lib/tech";
import { TagChip } from "@/lib/tags";
import SmartImage from "@/components/SmartImage";
import FreshBadge from "@/components/FreshBadge";

const InsightCard = ({ item, idx = 0, featured = false }) => {
  const { t, lang } = useLang();
  const to = `/insights/${item.id}`;
  return (
    <article
      data-testid={`insight-card-${idx}`}
      className={`dl-card flex ${featured ? "flex-col md:flex-row" : "flex-col"} group overflow-hidden`}
    >
      <Link to={to} className={`${featured ? "md:w-1/2 h-56 md:h-auto" : "h-44"} bg-[#F3F4F6] overflow-hidden block shrink-0`}>
        <SmartImage
          entity={item}
          type="insight"
          alt={item.title || "Dataleo insight"}
          className="w-full h-full transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="p-6 flex flex-col gap-3 flex-1">
        <div className="flex items-center gap-2">
          <span className="dl-overline text-[#00A878]">Dataleo Insight</span>
          {item.category && (
            <span className="dl-overline text-[#111827]">· {item.category}</span>
          )}
          <FreshBadge publishedAt={item.published_at} createdAt={item.created_at} lang={lang} />
          <span className="dl-overline ml-auto">{item.published_at}</span>
        </div>
        <h3 className={`font-display ${featured ? "text-3xl" : "text-xl"} leading-tight text-[#111827]`}>
          <Link to={to} className="group-hover:text-[#00A878] transition-colors">
            {item.title}
          </Link>
        </h3>
        {item.subtitle && (
          <p className="text-[15px] text-[#4B5563] leading-relaxed">{item.subtitle}</p>
        )}
        {(item.technologies && item.technologies.length > 0) && (
          <div className="flex flex-wrap gap-1">
            {item.technologies.slice(0, 5).map((tech) => (
              <TechChip key={tech} name={tech} variant="dark" size="xs" />
            ))}
          </div>
        )}
        <div className="flex flex-wrap gap-2 mt-auto pt-2">
          {(item.tags || []).slice(0, 3).map((tg) => (
            <TagChip key={tg} value={tg} />
          ))}
        </div>
        <Link to={to} className="text-sm font-medium text-[#111827] mt-1 hover:text-[#00A878]">
          {t.sections.readMore} →
        </Link>
      </div>
    </article>
  );
};

export default InsightCard;
